/**
 * Formatea un valor numérico como moneda mexicana (MXN).
 * Usa toLocaleString("es-MX") con símbolo $, separador de miles y 2 decimales.
 * Maneja null, undefined y NaN retornando "$0.00".
 *
 * @param {*} value - Valor a formatear
 * @returns {string} Valor formateado como moneda (ej: "$1,200.00")
 */
export const formatCurrency = (value) => {
  const num = Number(value);
  const safeNum = isNaN(num) ? 0 : num;
  return `$${safeNum.toLocaleString("es-MX", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
